import $ from 'jquery';

$(document).ready(function() {
  $(document).on("click", ".js-quantity__change", e => {
    var newQty = 1;
    var $parent = $(e.currentTarget).closest(".js-quantity");
    var $input = $parent.find('.js-quantity__input').first();
    if($(e.currentTarget).data("action") == 'less') {
      newQty = parseInt($input.val(), 10)-1;
    } else {
      newQty = parseInt($input.val(), 10)+1;
    }
    if( 0 <= newQty ) {
      $input.val(newQty).trigger('change');
    }

    e.preventDefault();
    e.stopPropagation();
  });

  $(document).on("change keydown keyup", ".js-quantity__input", e => {
    var max = parseInt($(e.currentTarget).attr('max'));
    var min = parseInt($(e.currentTarget).attr('min'));
    if ($(e.currentTarget).val() > max){
      $(e.currentTarget).val(max);
    }
    else if ($(e.currentTarget).val() < min){
      $(e.currentTarget).val(min);
    }
  });

  $(document).on("focus", ".js-quantity__input", e => {
    var $parent = $(e.currentTarget).closest(".js-quantity");
    $parent.addClass('is-focused');
  });

  $(document).on("blur", ".js-quantity__input", e => {
    var $parent = $(e.currentTarget).closest(".js-quantity");
    $parent.removeClass('is-focused');
  });
});


// WEBPACK FOOTER //
// ./scripts/components/Quantity.js